import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ParticipantOption, ParticipantPriceType } from '@cds/betting-offer';
import { EventOption } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import {
    AntepostParticipantsViewModel,
    FixtureParticipantPriceMap,
    V3FixtureParticipantPriceMap,
    WinGameParticipant,
} from '@frontend/sports/racing/feature/models';

import { HorsesFixturePricingHelper } from '../../../horse-racing-shared/services/horses-fixture-pricing-helper.service';
import { AntepostParticipantsComponent } from './antepost-participants.component';

@Component({
    selector: 'ms-antepost-container',
    templateUrl: 'antepost-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AntepostContainerComponent {
    @Input() vm: AntepostParticipantsViewModel<FixtureParticipantPriceMap> = AntepostParticipantsComponent.emptyViewModel;
    @Input() crmPromotedOptionIdsMap?: StringDictionary<number> = {};
    @Input() participant: WinGameParticipant;
    @Input() isSports: boolean;

    constructor(
        public sitecore: Sitecore,
        private horsesFixturePricingHelper: HorsesFixturePricingHelper,
    ) {}

    isLocked(price: EventOption | ParticipantOption | null, participant: WinGameParticipant): boolean {
        if (this.isSports) {
            return !this.vm.fixture || this.horsesFixturePricingHelper.isPriceLocked(this.vm.fixture, participant, price as ParticipantOption);
        }

        return !this.vm.fixture || this.horsesFixturePricingHelper.isDerivedMarketPriceLocked(this.vm.fixture, participant, price as EventOption);
    }

    isStartingPrice(price: EventOption | ParticipantOption): boolean {
        if (this.isSports) {
            return (price as ParticipantOption).priceType === ParticipantPriceType.StartingPrice;
        }

        return (price as EventOption).participantPriceType === ParticipantPriceType.StartingPrice;
    }

    get options(): FixtureParticipantPriceMap | V3FixtureParticipantPriceMap {
        if (this.isSports) {
            return this.vm.options;
        }

        return this.vm.options as V3FixtureParticipantPriceMap;
    }
}
